import { render } from "./DialogBookRestoreAlert.vue?vue&type=template&id=7475875d"
import script from "./DialogBookRestoreAlert.vue?vue&type=script&lang=js"
export * from "./DialogBookRestoreAlert.vue?vue&type=script&lang=js"
script.render = render

export default script